export class Admin {
    id:number
    firstName:string;
    lastName:string;
    email:string;
    password:string
    }
    